import React, { Fragment, useState } from "react"
import moment from "moment"
import { FormattedMessage } from "react-intl"

const KitTracking = ({ tracking }) => {
  const trackingInfoPath = (step, isLast) => {
    return (
      <div className="tracking-modal-row__icon-container">
        <div className={"icon"}>
          <div className={"icon-data"}>
            <div className={`point ${step?.achieved ? "active" : ""}`}></div>
          </div>
        </div>
        {isLast === false && <div className={`bottom-line ${step?.achieved ? "active" : ""}`}></div>}
      </div>
    )
  }

  const formatDate = (date) => {
    if (date && date?.length > 0) return moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm")
    return ""
  }

  return (
    <Fragment>
      <div className="tracking-modal-container">
        {tracking?.length === 0 && (
          <div>
            <FormattedMessage id={"kit.noTracking"} />
          </div>
        )}
        {tracking.map((globalStep, globalStepIndex) => {
          return (
            <div className={"tracking-modal-row"}>
              {trackingInfoPath(globalStep, globalStepIndex === tracking?.length - 1)}
              <div className={"tracking-modal-row__item"}>
                <div className="tracking-modal-row__title">
                  <div>
                    <span>{globalStep?.name}</span>
                  </div>
                  <div>
                    <span style={{ fontSize: 14 }}>{formatDate(globalStep?.date)}</span>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </Fragment>
  )
}

export default KitTracking
